// src/redux/slices/mapsSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Thunk to fetch autocomplete suggestions
export const fetchAutocomplete = createAsyncThunk(
  "maps/fetchAutocomplete",
  async (input, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/maps/autocomplete?input=${input}`);
      return response.data.address; // List of detailed places
    } catch (error) {
      return rejectWithValue(error.response?.data || "Autocomplete failed");
    }
  }
);

// Thunk to fetch place details from placeId
export const fetchPlaceDetails = createAsyncThunk(
  "maps/fetchPlaceDetails",
  async (placeId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/maps/place-details?placeId=${placeId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Place detail fetch failed"
      );
    }
  }
);

const mapsSlice = createSlice({
  name: "maps",
  initialState: {
    autocompleteResults: [],
    selectedPlaceDetails: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearAutocomplete: (state) => {
      state.autocompleteResults = [];
    },
    clearPlaceDetails: (state) => {
      state.selectedPlaceDetails = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Autocomplete
      .addCase(fetchAutocomplete.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAutocomplete.fulfilled, (state, action) => {
        state.loading = false;
        state.autocompleteResults = action.payload; // Full place objects
      })
      .addCase(fetchAutocomplete.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Place Details
      .addCase(fetchPlaceDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlaceDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedPlaceDetails = action.payload;
      })
      .addCase(fetchPlaceDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearAutocomplete, clearPlaceDetails } = mapsSlice.actions;
export default mapsSlice.reducer;
